"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withNaviFetch = withNaviFetch;
// Helper function to wrap Navi protocol function calls with fetch polyfill
// This addresses CORS issues with User-Agent header on Safari/iPhone
async function withNaviFetch(fn) {
    const originalFetch = globalThis.fetch;
    const headerWrappedFetch = async (input, init) => {
        try {
            const url = typeof input === "string" ? input : input?.url;
            const isNavi = typeof url === "string" &&
                /\.naviprotocol\.io$/i.test(new URL(url).hostname);
            if (!isNavi) {
                return originalFetch(input, init);
            }
            return originalFetch(input, {
                ...init,
                headers: {
                    ...init?.headers,
                    Host: "app.naviprotocol.io",
                    "User-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/138.0.0.0 Safari/537.36",
                    Referer: "https://app.naviprotocol.io/",
                    origin: "app.naviprotocol.io",
                },
            });
        }
        catch {
            // Fallback: if URL parsing fails, just use the original fetch
            return originalFetch(input, init);
        }
    };
    // Override fetch only within this function's execution
    globalThis.fetch = headerWrappedFetch;
    try {
        return await fn();
    }
    finally {
        globalThis.fetch = originalFetch;
    }
}
//# sourceMappingURL=naviPolyfill.js.map